import { api } from "core/axios/axios";
import type { AuthorizeResponse, IntegrationsListRes } from "./types";

export async function fetchIntegrationsData(): Promise<IntegrationsListRes> {
    const { data } = await api.get("app");
    return data;
}

export async function connectApp(name: string): Promise<AuthorizeResponse> {
    const { data } = await api.post(
        `app/authorize?app_name=${encodeURIComponent(name)}`,
        {}
    );
    return data;
}
